<template>
  <div class="upcoming-events-carousel">
    <carousel
      variant="show1"
      selector=".carousel-wrapper"
    >
      <div
        slot-scope="{ imageLoadedEvent, canLoad }"
        class="carousel component"
      >
        <div
          class="carousel-wrapper show1"
        >
          <UpcomingEventsSlide
            v-for="(event, index) in carouselEventsList"
            :key="`carousel-event-${event.eventId}-${index}`"
            :event="event"
            :image-loaded-event="imageLoadedEvent"
            :can-load="canLoad"
          />
        </div>
      </div>
    </carousel>
  </div>
</template>

<script>
  import UpcomingEventsSlide from './upcoming-events-slide.vue'

  export default {
    name: 'UpcomingEventsCarousel',
    components: {
      UpcomingEventsSlide,
    },
    inject: ['events'],
    computed: {
      /**
       * For carousel variant we show only 1 slide per event.
       * We add the next 2 events with same eventId inside the additionalDates
       * array to show inside the carousel slide details.
      */
      carouselEventsList() {
        const today = new Date()
        today.setHours(0, 0, 0, 0)

        const futureEvents = this.events.filter((event) => {
          const eventStartDate = new Date(event.eventStartDate)
          return eventStartDate >= today
        })

        const processedEventsMap = new Map()
        const finalEventList = []

        futureEvents.forEach((event) => {
          if (!processedEventsMap.has(event.eventId)) {
            const mainEvent = { ...event }
            mainEvent.additionalDates = []

            processedEventsMap.set(event.eventId, mainEvent)
            finalEventList.push(mainEvent)
          } else {
            const mainEvent = processedEventsMap.get(event.eventId)

            if (mainEvent.additionalDates.length < 2) {
              mainEvent.additionalDates.push({
                eventStartDate: event.eventStartDate,
                eventStartTime: event.eventStartTime,
                eventEndTime: event.eventEndTime
              })
            }
          }
        })

        finalEventList.sort((a, b) => new Date(a.eventStartDate) - new Date(b.eventStartDate))

        return finalEventList
      }
    },
  }
</script>
